import { ListValue } from "../../ListValue";

export class ClaimSubCategory {
  static List(): ListValue[] {
    let list: ListValue[] = [
      { id: "None", name: "none" },
      { id: "All", name: "all" },
      { id: "Self", name: "self" },
      { id: "Linked", name: "linked" },
      { id: "Campaign", name: "campaign" },
      { id: "Member", name: "member" },
      { id: "Organization", name: "organization" },
      { id: "Subscription", name: "subscription" },
    ];

    return list;
  }

  static Name(id: string): string {
    let rtn: string = "";

    ClaimSubCategory.List().forEach((obj) => {
      if (obj.id == id) {
        rtn = obj.name;
      }
    });

    return rtn;
  }

  static Value(name: string): string {
    let rtn: string = "";

    ClaimSubCategory.List().forEach((obj) => {
      if (obj.name == name) {
        rtn = obj.id;
      }
    });

    return rtn;
  }
}
